import React from "react";
import { Box, Typography, LinearProgress, Paper } from "@mui/material";
import { styled } from "@mui/material/styles";
import { useTranslation } from "react-i18next";
import { getVipRankLabel } from "../../utils/vipRank";

const StyledLinearProgress = styled(LinearProgress)(({ theme }) => ({
  height: 16, // Slightly thicker for visual impact
  borderRadius: 8,
  backgroundColor: "rgba(255, 255, 255, 0.1)",
  "& .MuiLinearProgress-bar": {
    borderRadius: 8,
    backgroundImage: "linear-gradient(90deg, #FFD700 0%, #FFA500 100%)",
    boxShadow: "0 0 15px rgba(255, 215, 0, 0.4)"
  },
}));

const VipHeaderSummary = ({ ranks, currentDeposit, userRank }) => {
  const { t } = useTranslation();
  let currentRankIndex = 0;
  if (userRank) {
    const rankNum = parseInt(userRank.replace(/VIP/i, '') || "0");
    const foundIndex = ranks.findIndex(r => parseInt(r.vipRank) === rankNum);
    if (foundIndex !== -1) currentRankIndex = foundIndex;
  }

  const currentRank = ranks[currentRankIndex];
  const nextRank = ranks[currentRankIndex + 1];
  const needed = nextRank ? Math.max(0, nextRank.accumulatedDeposit - currentDeposit) : 0;
  const currency = process.env.REACT_APP_CURRENCY_CODE || "USD";

  let progress = 0;
  if (nextRank) {
    progress = Math.min((currentDeposit / nextRank.accumulatedDeposit) * 100, 100);
  } else {
    progress = 100;
  }

  return (
    <Paper 
      elevation={0}
      sx={{ 
        p: 3, 
        bgcolor: 'rgba(15, 23, 42, 0.6)', // Semi-transparent background
        border: '1px solid rgba(255,255,255,0.1)',
        borderRadius: 4,
        textAlign: 'center' // Center alignment
      }}
    >
      <Typography variant="h5" fontWeight="bold" color="white" gutterBottom>
        {t("vipnew.viprankings")}
      </Typography>
      
      {/* Progress Info Row */}
      <Box display="flex" justifyContent="space-between" alignItems="flex-end" mb={1} px={1}>
         <Box textAlign="left">
           <Typography variant="caption" color="grey" display="block"> {t("vipnew.current")}</Typography>
           <Typography variant="h6" color="#FFD700" fontWeight="bold" lineHeight={1}>
             {getVipRankLabel(currentRank)}
           </Typography>
         </Box>

         <Box textAlign="right">
           <Typography variant="caption" color="grey" display="block"> {t("vipnew.target")}</Typography>
           <Typography variant="h6" color="white" fontWeight="bold" lineHeight={1}>
             {getVipRankLabel(nextRank, 'MAX')}
           </Typography>
         </Box>
      </Box>

      {/* The Bar */}
      <Box position="relative">
        <StyledLinearProgress variant="determinate" value={progress} />
        {/* Centered Text Overlay */}
        <Typography 
          variant="caption" 
          sx={{ 
            position: 'absolute', 
            top: '50%', 
            left: '50%', 
            transform: 'translate(-50%, -50%)', 
            color: 'white', 
            textShadow: '0 1px 2px black',
            fontWeight: 'bold',
            zIndex: 1
          }}
        >
          {currentDeposit.toLocaleString()} / {nextRank ? nextRank.accumulatedDeposit.toLocaleString() : currentDeposit.toLocaleString()}
        </Typography>
      </Box>

      {nextRank && (
        <Typography variant="body2" color="#94a3b8" sx={{ mt: 1.5 }}>
           {t("vipnew.deposit")} <span style={{color: 'white', fontWeight: 'bold'}}>{needed.toLocaleString()} {currency}</span> {t("vipnew.tolevel")}
        </Typography>
      )}
    </Paper>
  );
};

export default VipHeaderSummary;